import { render } from "./DocumentFormat.vue?vue&type=template&id=0e2c0300"
import script from "./DocumentFormat.vue?vue&type=script&lang=js"
export * from "./DocumentFormat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__